import { useEffect } from "react";

const BASE_TITLE = "Shopify Dev OAuth";

/**
 * Sets the document title with a consistent suffix.
 * @param title - The page-specific title (e.g., "Apps", "Miami Heat App")
 *                Pass null/undefined to use just the base title
 */
export function usePageTitle(title?: string | null) {
  useEffect(() => {
    document.title = title ? `${title} | ${BASE_TITLE}` : BASE_TITLE;

    // Reset to base title on unmount
    return () => {
      document.title = BASE_TITLE;
    };
  }, [title]);
}
